// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  envName: 'production',
  API_END_POINT_URL: 'https://sacha.am.veolia.fr/',
  logoutUrl: 'https://sacha.am.veolia.fr/login',
  CAN_USE_MOCK: false,
  google_analytics_code:  "G-09MNSLCVY2",
  refresh_google_when_expire_in: 15,
  refresh_jwt_when_expire_in: 1,
  // Clé de prod non existante
  google_client_id: '267060907829-1pghcgsuibvgoe9t84bqvpnft9b8j9et.apps.googleusercontent.com',
  APP_ID: '267060907829',
  DEV_KEY: 'AIzaSyCtc4PvWM_MtmkfSam-hvFN1SaQT7A3Gbs',
  BP_ACTIF: true,
  CREATE_BP: false,
  ISDELEG: false,
  datadog_env: {
    applicationId: '3477fdd9-72e8-4b21-9774-819c7af0ba9d',
    clientToken: 'puba919394a13cead7e53759a69954dc251',
    site: 'datadoghq.eu',
    service: 'sacha',
    env: 'production',
    // Specify a version number to identify the deployed version of your application in Datadog 
    version: '2.3.8',
    sampleRate: 100,
    allowedTracingOrigins: ['https://sacha.am.veolia.fr'],
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
